// Module
var code = "<template> <require from=\"./scroll-sentinel.scss\"></require> <div show.bind=\"pending\"> <slot></slot> </div> </template> ";
// Exports
module.exports = code;